// extracted by mini-css-extract-plugin
module.exports = {"edrpou":"columns_edrpou__3Nfde","icon":"columns_icon__32hNr"};